import { useTranslation } from "react-i18next";
import { Message } from "semantic-ui-react";

export default function NoDataAvailable({ message }) {
	const { t } = useTranslation();

	return <Message>{message || t("noDataAvailable", "No data available")}</Message>;
}
